// extracted by mini-css-extract-plugin
module.exports = {"Contact":"About_Contact__X_tY4","Contact__title":"About_Contact__title__3QZgg","Contact__p":"About_Contact__p__2wERX"};